export interface IRequestDocumentModel {
    id?: string;
    updated_at?: Date;
    created_at?: Date;
    is_active?: boolean;
    created_by?: string;
    updated_by?: string;
    request?: string;
    document?: any;
}

export class RequestDocumentModel {
    id?: string;
    updated_at?: Date;
    created_at?: Date;
    is_active?: boolean;
    created_by?: string;
    updated_by?: string;
    request?: string;
    document?: any;

    constructor() {
        this.id = null;
        this.updated_at = null;
        this.created_at = null;
        this.is_active = true;
        this.created_by = null;
        this.updated_by = null;
        this.request = null;
        this.document = null;
    }

    getSavePayload(): IRequestDocumentModel {
        return {
            is_active: this.is_active,
            request: this.request,
            document: typeof this.document == 'object' && this.document != null ? this.document.id : this.document,
        }
    }
}